import React from 'react'
import { Col, Row } from 'reactstrap'
import "./sponsorbilgipanel.css"

export default function SponsorBilgiPaneli({ sponsor })
{
    return (
        <Row className='ml-5 mt-2 mb-5'>
            <Col sm="12">
                <div className={`${sponsor?.className} sponsor`}>
                    <h3 className="display-4 text-center">{sponsor?.title} </h3>
                </div>
                <div className="display-6 text-center">
                    Sponsorluk İçeriği
                </div>
                <div className={`${sponsor?.className} sponsor`}>
                    <ul className='list-group'>
                        {sponsor?.features.map((item, index) => (
                            <li className='my-1 p-3 border-bottom'>{item?.text}</li>
                        ))}
                    </ul>
                </div>
            </Col>
        </Row>
    )
}
